/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot re-loadable.
 */

import SampleModuleReducers from './SampleModule/reducers';

import UAUserAccountReducers from './UAUserAccount/reducers';

import VerificationsReducers from './Verifications/reducers';

import CaseProgramsProductDeliveriesReducers from './CaseProgramsProductDeliveries/reducers';

import ACESDocumentServiceReducers from './ACESDocumentService/reducers';

import ACESWithdrawalReducers from './ACESWithdrawal/reducers';

import ACESFundReducers from './ACESFund/reducers';

import ACESSubmittedApplicationsReducers from './ACESSubmittedApplications/reducers';

import ACESUserRegistrationReducers from './ACESUserRegistration/reducers';

import ACESUserInfoReducers from './ACESUserInfo/reducers';

import ACESWaitlistReducers from './ACESWaitlist/reducers';

import ACESFIReducers from './ACESFI/reducers';

import ACESProviderSearchReducers from './ACESProviderSearch/reducers';

import ACESApplyForBenefitsReducers from './ACESApplyForBenefits/reducers';

/**
 * Creates the main reducer which combines all the reducers from the modules
 * and any provided reducers supplied from the wrapping application.
 *
 * Provided reducers are ignored where there is a clash in naming.
 *
 * @namespace UAReduxReducers
 */
export default {
  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASampleModule: SampleModuleReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAUAUserAccount: UAUserAccountReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAVerifications: VerificationsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UACaseProgramsProductDeliveries: CaseProgramsProductDeliveriesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESDocumentService: ACESDocumentServiceReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESWithdrawal: ACESWithdrawalReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESFund: ACESFundReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESSubmittedApplications: ACESSubmittedApplicationsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESUserRegistration: ACESUserRegistrationReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESUserInfo: ACESUserInfoReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESWaitlist: ACESWaitlistReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESFI: ACESFIReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESProviderSearch: ACESProviderSearchReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAACESApplyForBenefits: ACESApplyForBenefitsReducers.reducers,
};
